import { Doughnut } from "react-chartjs-2";
import { useEffect, useState } from "react";
import { Chart, ArcElement, ChartData, Legend, Title, Tooltip as ChartJsTooltip, Colors } from 'chart.js'
import { CardElementName } from "../../models/CardElement";
import { classNames } from "../../style/common";

Chart.register(
    ArcElement,
    ChartJsTooltip,
    Title,
    Colors,
    Legend
);

export type ElementDoughnutProps = {
    elementQuantities: Record<CardElementName, number>,
    showLabel: boolean,
    classNames?: {
        container?: string | undefined
    }
}

const getDefaultElementChartState: (data?: number[]) => ChartData<"doughnut", number[], string> = (data?: number[]) => {
    return {
        datasets: [
            {
                data: data ?? [0],
                backgroundColor: ["red", "#6cb0d3", "#6eaa84", "yellow", "#965c93", "#3f67b4", "#909090", "#222"]
            }
        ],
        labels: [
            "fire", "ice", "wind", "earth", "lightning", "water", "light", "dark"
        ]
    };
}

export function ElementDoughnut(props: ElementDoughnutProps) {
    const [elementChartData, setElementChartData] = useState<ChartData<"doughnut", number[], string>>(getDefaultElementChartState());

    useEffect(() => {
        setElementChartData(getDefaultElementChartState([
            props.elementQuantities["Fire"] ?? 0,
            props.elementQuantities["Ice"] ?? 0,
            props.elementQuantities["Wind"] ?? 0,
            props.elementQuantities["Earth"] ?? 0,
            props.elementQuantities["Lightning"] ?? 0,
            props.elementQuantities["Water"] ?? 0,
            props.elementQuantities["Light"] ?? 0,
            props.elementQuantities["Dark"] ?? 0,
        ]));
    }, [props.elementQuantities]);

    return (
        <div className={classNames("justify-center flex", props.classNames?.container)}>
            <Doughnut
                data={elementChartData}
                options={{
                    responsive: true,
                    plugins: {
                        tooltip: {
                            enabled: true
                        },
                        legend: {
                            display: false
                        },
                        title: props.showLabel
                            ? {
                                display: true,
                                text: "Element Distribution",
                                color: "gray"
                            }
                            : undefined
                    }
                }} />
        </div>
    )
}